import React from 'react';
import {object, string, array} from 'prop-types';
import {withRouteData} from 'react-static';
import Prismic from 'prismic-javascript';
import {RichText} from 'prismic-reactjs';
import linkResolver from '../utils/link-resolver';
import PrismicPreview from '../components/prismic-preview';
import Title from '../components/title/title';
import ContactInfo from '../components/contact-info/contact-info';
import ContactForm from '../components/contact-form/contact-form';
import ContactMap from '../components/contact-map/contact-map';

class Book extends React.Component {
  componentDidMount() {
    setTimeout(() => window.requestAnimationFrame(window.ataction), 0);
    setTimeout(() => window.requestAnimationFrame(window.ataction), 500);
  }

  render() {
    return (
      <PrismicPreview
        publishedContent={this.props}
        query={{predicates: Prismic.Predicates.at('document.type', 'book')}}
      >
        {({
          title,
          intro_text,
          mobile,
          phone,
          email,
          address,
          accepted_payment_methods
        }) => (
          <>
            <ContactMap address={address} />

            {title && (
              <Title
                title={RichText.asText(title)}
                text={RichText.render(intro_text, linkResolver)}
                maxWidth={791}
              />
            )}

            <section>
              <div className="container">
                <div className="row">
                  <div className="col-md-4">
                    <ContactInfo
                      mobile={mobile}
                      phone={phone}
                      email={email}
                      address={address}
                      acceptedPaymentMethods={accepted_payment_methods}
                    />
                  </div>
                  <div className="col-md-8">
                    <ContactForm />
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </PrismicPreview>
    );
  }
}

Book.propTypes = {
  title: array.isRequired,
  intro_text: array.isRequired,
  mobile: string.isRequired,
  phone: string.isRequired,
  email: string.isRequired,
  address: string.isRequired,
  accepted_payment_methods: object.isRequired
};

export default withRouteData(Book);
